/* istanbul ignore file */

export enum MapOverlayComponents {
    MapLayersControlForm = 'kh-map-layers-control-form',
    MapFiltersForm = 'kh-map-filters-form',
    MapSiteDataPreview = 'kh-map-site-data-preview',
    MapLayerDetail = 'kh-map-layer-detail',
    MapLegend = 'kh-map-legend',
    MapFieldPointModal = 'kh-map-field-point-modal'
}
